import React from 'react';
import { StyleSheet, Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import { UserClub } from '../types';
import { Select } from './Select';
import { imageService } from '../services/images';

interface ClubFilterDropdownProps {
  userClubs: UserClub[];
  /** Selected club id ('' = all clubs). Controlled by the parent so the
   * dropdown can never get out of sync with the filter that is applied. */
  value: string;
  onSelect: (clubId: string) => void;
  /** Fixed width — the band toolbar sizes it at 260. */
  width?: number;
}

export const ClubFilterDropdown: React.FC<ClubFilterDropdownProps> = ({
  userClubs,
  value,
  onSelect,
  width,
}) => {
  const { t } = useTranslation();

  // Sort clubs alphabetically by name
  const sortedClubs = [...userClubs].sort((a, b) => {
    const nameA = a.club?.name?.toLowerCase() || '';
    const nameB = b.club?.name?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });

  const options = [
    { label: t('components.clubFilter.allClubs'), value: '' },
    ...sortedClubs.map((uc) => ({
      label: uc.club?.name || t('components.clubFilter.unknownClub'),
      value: uc.club_id,
      imageUrl: uc.club?.logo_url
        ? imageService.getLogoUrl(uc.club.logo_url, 'small')
        : undefined,
    })),
  ];

  return (
    <Select
      value={value}
      onValueChange={onSelect}
      options={options}
      placeholder={t('components.clubFilter.allClubs')}
      style={width != null ? [styles.wrapper, { width, minWidth: width, maxWidth: width }] : styles.wrapper}
      dropdownPosition="auto"
    />
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flexShrink: 0,
    minWidth: 180,
    marginBottom: 0, // Override Select's default marginBottom
    ...(Platform.OS === 'web' && {
      maxWidth: 250,
    }),
  },
});
